import React, { useState, useEffect } from "react";
import { API, UPLOADS } from "./../../config/api";
export default function Pendingworkspace() {
  const [showModal, setShowModal] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState(null);
  const [workspaces, setWorkspaces] = useState([]);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentImage, setPaymentImage] = useState("");

  useEffect(() => {
    fetchWorkspaces();
  }, []);

  const fetchWorkspaces = async () => {
    try {
      // UPDATED: Points to unified api.php with status=Pending filter
      const res = await fetch(API.LIST_PENDING_WORKSPACES);
      const data = await res.json();
      setWorkspaces(data);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const handleView = (workspace) => {
    setSelectedWorkspace(workspace);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setShowPaymentModal(false);
  };

  const updateStatus = async (status) => {
    // 1. Logic for Reject (Delete)
    if (status === "Rejected") {
      const confirmDelete = window.confirm(
        "Are you sure? Rejecting this workspace will permanently delete it and all its uploaded images.",
      );
      if (!confirmDelete) return;
    }

    try {
      const formData = new FormData();
      formData.append("id", selectedWorkspace.id);

      // UPDATED: Determine action based on status choice
      // 'Approved' updates the status; 'Rejected' triggers the full delete action

      if (status === "Active") {
        formData.append("status", "Active");
      }
      const apiUrl =
        status === "Rejected"
          ? API.DELETE_WORKSPACE
          : API.UPDATE_WORKSPACE_STATUS;

      const res = await fetch(apiUrl, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert(data.message);

      setShowModal(false);
      fetchWorkspaces(); // Refresh the table
    } catch (error) {
      console.error("Operation Error:", error);
    }
  };

  return (
    <div className="dashboard-content">
      <h2 className="machine-title">Pending Workspaces Requests</h2>

      <div className="table-responsive">
        <table className="machine-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User Id</th>
              <th>Date</th>
              <th>Owner</th>
              <th>City</th>
              <th>Rent</th>
              <th>Ads</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {workspaces.length > 0 ? (
              workspaces.map((item, index) => (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td data-label="user id">{item.user_id}</td>
                  <td>
                    {" "}
                    <div className="fw-bold">
                      {new Date(item.created_at).toLocaleDateString()}
                    </div>
                    <div className="text-muted small">
                      {new Date(item.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>
                  <td>
                    <div className="fw-bold">{item.owner_name}</div>
                    <div className="text-muted small">{item.phone}</div>
                  </td>
                  <td>{item.city}</td>
                  <td>₹ {Number(item.rent_price).toLocaleString("en-IN")}</td>
                  <td>
                    <div className="fw-bold">{item.show_ads_days} Days</div>
                    <div className="text-muted small">₹{item.ads_amount}</div>
                  </td>
                  <td>
                    <span className="status-pending">{item.status}</span>
                  </td>
                  <td>
                    <button
                      className="view-btn"
                      onClick={() => handleView(item)}
                    >
                      view
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="text-center py-4">
                  No pending workspace requests found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* POPUP MODAL */}
      {showModal && selectedWorkspace && (
        <div className="popup-overlay">
          <div className="popup-box">
            <div className="popup-header">
              <h3>🏢 Workspace Review</h3>
            </div>

            <div className="popup-grid">
              <div>
                <label>Owner</label>
                <p>{selectedWorkspace.owner_name}</p>
              </div>
              <div>
                <label>Mobile No</label>
                <p>{selectedWorkspace.phone}</p>
              </div>
              <div>
                <label>City/State</label>
                <p>
                  {selectedWorkspace.city}, {selectedWorkspace.state}
                </p>
              </div>
              <div>
                <label>Room Size</label>
                <p>{selectedWorkspace.size} </p>
              </div>
              <div>
                <label>Floor</label>
                <p>{selectedWorkspace.floor}</p>
              </div>
              <div>
                <label>Rent Price</label>
                <p>
                  ₹{" "}
                  {Number(selectedWorkspace.rent_price).toLocaleString("en-IN")}
                </p>
              </div>
              <div>
                <label>Location</label>
                <p>{selectedWorkspace.location}</p>
              </div>

              <div>
                <label>Ads Duration</label>
                <p>{selectedWorkspace.show_ads_days || "N/A"}</p>
              </div>

              <div>
                <label>Payed Amount:</label>
                <p>₹{selectedWorkspace.ads_amount || 0}</p>
              </div>

              {selectedWorkspace.payment_screenshot ? (
                <div className="payment-proof-section">
                  <label>Payment Screenshot</label>

                  <div
                    className="popup-images"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      setPaymentImage(
                        `${UPLOADS.WORKSPACE_IMAGE}${selectedWorkspace.payment_screenshot}`,
                      );
                      setShowPaymentModal(true);
                    }}
                  >
                    <img
                      src={`${UPLOADS.WORKSPACE_IMAGE}${selectedWorkspace.payment_screenshot}`}
                      alt="payment"
                      style={{
                        maxWidth: "300px",
                        borderRadius: "10px",
                        border: "1px solid #ddd",
                        padding: "5px",
                        transition: "transform 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = "scale(1.05)";
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = "scale(1)";
                      }}
                    />
                  </div>
                </div>
              ) : (
                <div>
                  <label>Payment Screenshot:</label>
                  <p>Not uploaded</p>
                </div>
              )}
            </div>
            {showPaymentModal && (
              <div
                className="image-modal-overlay"
                onClick={() => setShowPaymentModal(false)}
              >
                <div
                  className="image-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    className="image-close-btn"
                    onClick={() => setShowPaymentModal(false)}
                  >
                    ✖
                  </button>

                  <img
                    src={paymentImage}
                    alt="Payment Full"
                    className="full-payment-image"
                  />
                </div>
              </div>
            )}
            <div className="description-box">
              <label>Description</label>
              <p>{selectedWorkspace.description}</p>
            </div>

            <div className="popup-images">
              {selectedWorkspace.image &&
                selectedWorkspace.image
                  .split(",")
                  .map((img, i) => (
                    <img
                      key={i}
                      src={`${UPLOADS.WORKSPACE_IMAGE}${img}`}
                      alt="workspace"
                    />
                  ))}
            </div>

            <div className="modal-actions">
              <button
                className="btn btn-success"
                onClick={() => updateStatus("Active")}
              >
                Approve Listing
              </button>
              <button
                className="btn btn-danger"
                onClick={() => updateStatus("Rejected")}
              >
                Reject & Delete
              </button>
              <button className="btn btn-secondary" onClick={handleClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      )}
      {/* PAYMENT IMAGE FULLSCREEN MODAL */}
      {/* {showPaymentModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.9)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
          onClick={() => setShowPaymentModal(false)}
        >
          <div
            style={{
              position: "relative",
              maxWidth: "90vw",
              maxHeight: "90vh",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={() => setShowPaymentModal(false)}
              style={{
                position: "absolute",
                top: "-15px",
                right: "-15px",
                background: "#ff4444",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                fontSize: "18px",
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 10000,
                boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
              }}
            >
              ×
            </button>

            <img
              src={paymentImage}
              alt="Payment Proof Large"
              style={{
                maxWidth: "100%",
                maxHeight: "90vh",
                width: "auto",
                height: "auto",
                borderRadius: "12px",
                boxShadow: "0 20px 60px rgba(0,0,0,0.5)",
                objectFit: "contain",
              }}
            />
          </div>
        </div>
      )} */}
    </div>
  );
}
